// Constants file containing all our mixpanel event names.

export const OnMainSurvey = "OnMainSurvey";
export const OnPaymentSurvey = "OnPaymentSurvey";

export const OnHMMainSurvey = "OnHMMainSurvey";
export const OnHMPaymentSurvey = "OnHMPaymentSurvey";
